import axioPath from 'api/axioPath';
import ptPlusApiBaseUrl from 'api/ptPlusApiBaseUrl';
import { showAppLoader, hideAppLoader } from '../app';

export const fetchPickupOrders = (apiUrl, data, token, authID) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath.post(apiUrl, data, {
    headers: {
      Authorization: token,
      authId: authID
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    return ex;
  });
};

export const fetchPickupOrderBaggageCountAPI = (data, token) => (dispatch) => {
  return axioPath.post('order/v2/pickup/get_bagage_count', data, {
    headers: {
      Authorization: token,
    },
  }).then((response) => {
    return response.data;
  }).catch((ex) => {
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    return ex;
  });
};

export const orderBaggageReadApi = (tab, token) => (dispatch) => {
  return axioPath.get(`order/bagageInfo/update/isRead/${tab}`, {
    headers: {
      Authorization: token,
    },
  }).then((response) => {
    return response.data;
  }).catch((ex) => {
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    return ex;
  });
};

export const pickupOrderDeclineApi = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath.post('/order/pickup/decline_tender', data, {
    headers: {
      Authorization: `${token}`,
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const deliveryReqOrderDeclineApi = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath.post('/order/delivery/decline_tender', data, {
    headers: {
      Authorization: `${token}`,
    },
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
    else return ex;
  });
};

export const orderPickedApi = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/order/v2/pickup/order_pickedup', data, {
      headers: {
        Authorization: `${token}`,
      },
    }).then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    }).catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const getPalletDetailsApi = (data, token) => (dispatch) => {
  return ptPlusApiBaseUrl
    .post('ptms/buyback/buybackfee_byid', data, {
      headers: {
        Authorization: `${token}`,
      },
    }).then((response) => {
      return response.data;
    }).catch((ex) => {
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const claimRaiseApi = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/order/pickup/claim_raise', data, {
      headers: {
        Authorization: `${token}`,
      },
    }).then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    }).catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const claimAcceptDeclineApi = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/order/pickup/claim/accept_decline', data, {
      headers: {
        Authorization: `${token}`,
      },
    }).then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    }).catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const cancelRescheduleOrderApi = (url, data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post(url, data, {
      headers: {
        Authorization: `${token}`,
      },
    }).then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    }).catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const rescheduleAcceptDeclineApi = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/order/pickup/reschedule/accept_decline', data, {
      headers: {
        Authorization: `${token}`,
      },
    }).then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    }).catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const qtyUpdateApi = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/order/pickup/ptms/update_quantity', data, {
      headers: {
        Authorization: `${token}`,
      },
    }).then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    }).catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const supRefNoUpdateApi = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/order/pickup/update_pickup_order', data, {
      headers: {
        Authorization: `${token}`,
      },
    }).then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    }).catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const downloadInvoiceApi = (id, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath.get('/order/invoice/downloadpdf?invoiceId=' + id, {
    headers: {
      Authorization: `${token}`,
      'Content-Type': "application/octet-stream"
    },
    responseType: 'blob',
  }).then((response) => {
    dispatch(hideAppLoader());
    return response.data;
  }).catch((ex) => {
    dispatch(hideAppLoader());
    return ex;
  });
};

export const fetchPaymentMethodsApi = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/order/v2/user/get_payment_details', data, {
      headers: {
        Authorization: `${token}`,
      },
    }).then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    }).catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const retryPaymentApi = (data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post('/order/v2/payment/retry_payment', data, {
      headers: {
        Authorization: `${token}`,
      },
    }).then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    }).catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};

export const orderReportsApi = (url, data, token) => (dispatch) => {
  dispatch(showAppLoader());
  return axioPath
    .post(url, data, {
      headers: {
        Authorization: `${token}`,
      },
    }).then((response) => {
      dispatch(hideAppLoader());
      return response.data;
    }).catch((ex) => {
      dispatch(hideAppLoader());
      if (ex.response) return { error: true, data: ex.response?.data, statusCode: ex.response?.status };
      else return ex;
    });
};